import { forwardRef } from 'react';

interface PlannedEventIconProps extends React.SVGProps<SVGSVGElement> {
  size?: 'small' | 'medium' | 'large';
}

const ICON_SIZES = {
  small: 20,
  medium: 24,
  large: 32,
};

const PlannedEventIcon = forwardRef<SVGSVGElement, PlannedEventIconProps>(
  ({ size = 'medium', ...props }, ref) => {
    const iconSize = ICON_SIZES[size];

    return (
      <svg
        id='add_road-24px'
        xmlns='http://www.w3.org/2000/svg'
        width={iconSize}
        height={iconSize}
        viewBox='0 0 24 25'
        ref={ref}
        {...props}
      >
        <g id='Group_339' data-name='Group 339'>
          <rect
            id='Rectangle_7'
            data-name='Rectangle 7'
            width='24'
            height='24'
            fill='rgba(255,255,255,0.87)'
            opacity='0'
          />
        </g>
        <g id='Group_341' data-name='Group 341'>
          <g id='Group_340' data-name='Group 340'>
            <rect
              id='Rectangle_8'
              data-name='Rectangle 8'
              width='2'
              height='4'
              transform='translate(18 4)'
            />
            <rect
              id='Rectangle_9'
              data-name='Rectangle 9'
              width='2'
              height='16'
              transform='translate(4 4)'
            />
            <rect
              id='Rectangle_10'
              data-name='Rectangle 10'
              width='2'
              height='4'
              transform='translate(11 4)'
            />
          </g>
        </g>
        <g id='insert_invitation-24px' transform='translate(8.292 9.483)'>
          <path id='Path_41' data-name='Path 41' d='M0,0H15.517V15.517H0Z' fill='none' />
          <path
            id='Path_42'
            data-name='Path 42'
            d='M12.052,8.112H8.819v3.233h3.233ZM11.405,1V2.293H6.233V1H4.94V2.293H4.293A1.287,1.287,0,0,0,3.006,3.586L3,12.638a1.293,1.293,0,0,0,1.293,1.293h9.052a1.3,1.3,0,0,0,1.293-1.293V3.586a1.3,1.3,0,0,0-1.293-1.293H12.7V1Zm1.94,11.638H4.293V5.526h9.052Z'
            transform='translate(-1.06 -0.353)'
          />
        </g>
      </svg>
    );
  }
);

export default PlannedEventIcon;
